import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const DEBUG = process.env.NODE_ENV !== 'production'
let module = 'ticket'
let modulePath = DEBUG ? '/' : `/${module}/`

const routes = [
  {
    path: '*',
    redirect: '/404',
  },
  {
    path: '/enter/:accountid/:projectid/:language?',
    name: 'Enter',
    component: () => import('@/views'),
    meta: {
      title: ' ',
    },
    redirect: '/ticket',
    children: [
      {
        path: '/ticket/:accountid/:projectid/:language?',
        name: 'Ticket',
        component: () =>
          import('@/views/Ticket'),
        meta: {
          title: ' ',
        },
      },
      {
        path: '/form/:accountid/:projectid/:language?',
        name: 'Form',
        component: () =>
          import('@/views/Form'),
        meta: {
          title: ' ',
        },
      },
    ],
  },
  {
    path: '/result/:accountid/:projectid/:orderid/:language?/:ispaypal?', // :type? 定义非必填参数
    name: 'Result',
    component: () =>
      import('@/views/Result'),
    meta: {
      title: ' ',
    },
  },
  {
    path: '/guide/:accountid/:projectid', // :type? 定义非必填参数
    name: 'Guide',
    component: () =>
      import('@/views/Guide'),
    meta: {
      title: ' ',
    },
  },
  {
    path: '/404',
    name: '404',
    component: () =>
      import('@/views/404/404'),
    meta: {
      title: ' ',
    },
  }
]

const router = new VueRouter({
  mode: 'history',
  base: modulePath,
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   return { x: 0, y: 0 }
  // },
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
